/** @file The UI catalogs by language code; catalogLanguages turns them into the Settings choices. */
import type { Catalog, PartialCatalog } from './types';
import { en } from './catalogs/en';
import { th } from './catalogs/th';

/** en is complete (catalogs/en.ts composes the per-area parts, W3-03); every other language is partial. */
export const CATALOGS: { en: Catalog } & Record<string, PartialCatalog> = { en, th };
